export const DEBOUNCE_TIME = 500

export const MIN_QUERY_LENGTH = 3
